import styled, { css } from 'styled-components';
import { ContainerType } from '../NodeEditorDrawer/ThresholdsTab/types';

export const AttributeEditorContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 6px;
  row-gap: 15px;
  padding: var(--cl-space-2);
`;

export const AttrComponentLabel = styled.span`
  margin: -12px 0 -1px 0px;
  padding-left: 5px;
  line-height: normal;
  font-size: 10px;
  color: var(--cl-gray-600);
`;

export const FootnoteSentencesContainer = styled.div<{
  mode: 'rule' | 'expression';
  containerType: ContainerType;
  newEditor: boolean;
}>`
  display: flex;
  flex-direction: column;
  padding: ${({ newEditor }) => (newEditor
    ? 'var(--cl-space-5) var(--cl-space-4) var(--cl-space-4) var(--cl-space-6)'
    : 'var(--cl-space-2) var(--cl-space-4) var(--cl-space-4) var(--cl-space-10)')};
  gap: 15px;

  ${({ mode }) => mode === 'expression' && css`
    padding-left: var(--cl-space-5);
  `}

  ${({ containerType }) => containerType === ContainerType.MODAL && css`
    padding: var(--cl-space-4) 0 0 0;
    gap: var(--cl-space-2);
  `}
`;

export const FootnoteItem = styled.div`
  display: flex;
  column-gap: 8px;
  row-gap: 6px;
  flex-wrap: wrap;
  color: var(--cl-gray-700);
  font-family: var(--cl-font-family-mono);
  font-size: var(--cl-font-size-1);
`;

export const FootnoteTokenContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: normal;
`;

export const StyledSuperset = styled.sup`
  color: var(--cl-gray-700);
  top: 0.3rem;
`;
